// Speech is only an input adapter. A transcript is reviewed before it is submitted.
const voiceSpeechApi = (() => {
  const start = ({ host = globalThis, lang, onText, onEnd, onError }: any) => {
    const R = host.SpeechRecognition || host.webkitSpeechRecognition
    if (!R) throw new Error('control.voiceUnsupported')
    const r = new R()
    let live = true
    r.lang = lang
    r.onresult = (event: any) => {
      if (!live) return
      const text = Array.from(event.results as any[]).filter((x: any) => x.isFinal)
        .map((x: any) => x[0]?.transcript || '').join(' ').trim()
      if (text) onText(text.slice(0, 2000))
    }
    r.onerror = () => { if (live) { live = false; onError('control.voiceFailed') } }
    r.onend = () => { if (live) { live = false; onEnd() } }
    const media = host.navigator?.mediaDevices
    if (media?.getUserMedia) {
      media.getUserMedia({ audio: true }).then((s: any) => {
        s.getTracks().forEach((x: any) => x.stop())
        if (live) r.start()
      }).catch(() => { if (live) { live = false; onError('control.voiceFailed') } })
    } else r.start()
    return () => { live = false; r.abort() }
  }
  return { start }
})()
Object.assign(globalThis, { PlummeInvoiceControlSpeech: voiceSpeechApi })
